import { render, staticRenderFns } from "./lista-listado.vue?vue&type=template&id=9067cbae&"
import script from "./lista-listado.vue?vue&type=script&lang=ts&"
export * from "./lista-listado.vue?vue&type=script&lang=ts&"
import style0 from "./lista-listado.vue?vue&type=style&index=0&id=9067cbae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDataTable,VIcon,VSkeletonLoader})
